/**
 * Kodeon API Client - Public API
 *
 * Exports a singleton instance of KodeonApiClient for all platform communication.
 * Both UI components and agents consume this module (transparency principle).
 */

import { KodeonApiClient, ApiClientError } from './client'

/**
 * Singleton API client instance.
 *
 * Must be configured with an API key at app startup:
 * ```typescript
 * import { getEnvironmentConfigs } from '@/lib/tauri'
 * import { api } from '@/lib/api'
 *
 * const configs = await getEnvironmentConfigs()
 * api.configure(configs.prod.api_key, configs.prod.gateway_url)
 * ```
 *
 * For runtime environment switching:
 * ```typescript
 * api.reconfigure(configs.dev.api_key, configs.dev.gateway_url)
 * ```
 */
export const api = new KodeonApiClient()

// Re-export class and error type for type references
export { KodeonApiClient, ApiClientError }
